const eventBus = {
  addEvent(event, callback) {
    document.addEventListener(event, (event) => callback(event.detail));
  },
  removeEvent(event, callback) {
    document.removeEventListener(event, callback);
  },
  dispatchEvent(event, detail) {
    document.dispatchEvent(new CustomEvent(event, { detail }));
  }
}

export default eventBus;
